import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { ManifestStagedShipment } from '../../core/api/lab.types';

export const manifestStagedShipmentHasErrorSelector = (state: RootState): any =>
  state.manifestStagedShipment.errors && state.manifestStagedShipment.errors
    ? { hasError: true, message: state.manifestStagedShipment.errors[0].message }
    : { hasError: false };

export const manifestStagedShipmentIsBusySelector = (state: RootState): boolean =>
  state.manifestStagedShipment.status === StoreStatus.BUSY;

export const manifestStagedShipmentResponseSelector = (state: RootState): ManifestStagedShipment | null =>
  state.manifestStagedShipment.response || null;
